document.addEventListener('DOMContentLoaded',function(){

/* 1. Card hearts -> navigate to product page */
function wwpPatchHearts(){
  document.querySelectorAll('[data-wwp-wishlist-handle]').forEach(function(btn){
    if(btn.dataset.wwpPatchBound)return;
    btn.dataset.wwpPatchBound='true';
    if(btn.hasAttribute('data-wwp-pdp-heart'))return;
    btn.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      window.location.href='/products/'+btn.dataset.wwpWishlistHandle;
    },true);
  });
}
wwpPatchHearts();
new MutationObserver(wwpPatchHearts).observe(document.body,{childList:true,subtree:true});

/* 2. Add to Bag label */
function wwpBagLabel(){
  document.querySelectorAll('[name="add"] span:first-child,.product-form__submit span:first-child').forEach(function(el){
    var t=el.textContent.trim();
    if(t==='Add to cart'||t==='Add to Cart')el.textContent='Add to Bag';
  });
}
wwpBagLabel();
new MutationObserver(wwpBagLabel).observe(document.body,{childList:true,subtree:true});

/* 3. Contact link fallback */
document.querySelectorAll('[data-wwp-contact-open]').forEach(function(el){
  if(el.tagName==='A')el.setAttribute('href','/pages/contact');
});

/* 4. Blog tag filter bar */
(function(){
  var blogGrid=document.querySelector('.blog-articles,.blog,.articles-grid,.blog__posts');
  if(!blogGrid||document.querySelector('.wwp-blog-tag-bar'))return;
  var mainTags=['Buying Guide','Dogs','Cats','Grooming','Health','Travel','Wellbeing','At Home'];
  var bar=document.createElement('div');
  bar.className='wwp-blog-tag-bar';
  bar.style.cssText='display:flex;flex-wrap:wrap;gap:8px;padding:0 0 24px;';
  var path=window.location.pathname;
  var activeTag=path.includes('/tagged/')?decodeURIComponent(path.split('/tagged/').pop()).replace(/\/$/,''):'';
  var allA=document.createElement('a');
  allA.href='/blogs/news';allA.textContent='All Posts';
  var isAll=!activeTag;
  allA.style.cssText='padding:7px 16px;border-radius:20px;font-size:13px;font-weight:600;text-decoration:none;border:1.5px solid '+(isAll?'#E0948F':'#D4C4B4')+';background:'+(isAll?'#E0948F':'transparent')+';color:'+(isAll?'#fff':'#6B6560')+';white-space:nowrap';
  bar.appendChild(allA);
  mainTags.forEach(function(tag){
    var a=document.createElement('a');
    a.href='/blogs/news/tagged/'+encodeURIComponent(tag);
    a.textContent=tag;
    var active=activeTag.toLowerCase()===tag.toLowerCase();
    a.style.cssText='padding:7px 16px;border-radius:20px;font-size:13px;font-weight:600;text-decoration:none;border:1.5px solid '+(active?'#E0948F':'#D4C4B4')+';background:'+(active?'#E0948F':'transparent')+';color:'+(active?'#fff':'#6B6560')+';white-space:nowrap';
    bar.appendChild(a);
  });
  blogGrid.parentNode.insertBefore(bar,blogGrid);
})();

/* 5. Free shipping progress bar in cart */
function wwpShippingBar(){
  document.querySelectorAll('.cart-drawer__footer,.cart__footer').forEach(function(footer){
    if(footer.querySelector('.wwp-fs-bar'))return;
    var wrap=document.createElement('div');
    wrap.className='wwp-fs-bar';
    wrap.style.cssText='padding:12px 0 6px;border-bottom:.5px solid #EDE5DA;margin-bottom:10px';
    footer.prepend(wrap);
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var threshold=4000;
      var total=cart.total_price;
      var remaining=threshold-total;
      var pct=Math.min(100,Math.round((total/threshold)*100));
      if(remaining<=0){
        wrap.innerHTML='<p style="text-align:center;font-size:12.5px;font-weight:600;color:#2d7a2d;padding:2px 0">You qualify for free delivery!</p>';
      }else{
        var fmt=String.fromCharCode(163)+(remaining/100).toFixed(2).replace('.00','');
        wrap.innerHTML='<p style="font-size:12px;color:#6B6560;text-align:center;margin-bottom:7px">Add <strong style="color:#2B2926">'+fmt+'</strong> more for free delivery</p><div style="height:5px;background:#EDE5DA;border-radius:3px;overflow:hidden"><div style="height:5px;background:#E0948F;border-radius:3px;width:'+pct+'%;transition:width .4s ease"></div></div>';
      }
    }).catch(function(){wrap.remove();});
  });
}
wwpShippingBar();
new MutationObserver(wwpShippingBar).observe(document.body,{childList:true,subtree:true});

/* 6. Continue Shopping in cart */
function wwpContinueShopping(){
  document.querySelectorAll('.cart-drawer__footer,.cart__footer').forEach(function(footer){
    if(footer.querySelector('.wwp-cs'))return;
    var a=document.createElement('a');
    a.href='/collections/shop-all';a.className='wwp-cs';a.textContent='Continue Shopping';
    a.style.cssText='display:block;text-align:center;padding:10px 0 2px;font-size:13px;font-weight:600;color:#6B6560;text-decoration:none;letter-spacing:.02em;transition:color .15s';
    a.onmouseenter=function(){a.style.color='#E0948F';};
    a.onmouseleave=function(){a.style.color='#6B6560';};
    footer.appendChild(a);
  });
}
wwpContinueShopping();
new MutationObserver(wwpContinueShopping).observe(document.body,{childList:true,subtree:true});

/* 7. Reorder reminder on product pages (subscribe alternative) */
(function(){
  var isProduct=document.querySelector('.product-form__submit,.product__title');
  if(!isProduct)return;
  var handle=window.location.pathname.split('/products/')[1];
  if(!handle)return;
  var consumables=['food','water','litter','treat','bag','pad','supplement','vitamin','flea','worm','dental','shampoo'];
  var title=document.querySelector('.product__title h1,.product-form__title')?.textContent?.toLowerCase()||'';
  var isConsumable=consumables.some(function(k){return title.includes(k)||handle.includes(k)});
  if(!isConsumable)return;
  var form=document.querySelector('.product-form');
  if(!form||form.querySelector('.wwp-reorder'))return;
  var div=document.createElement('div');
  div.className='wwp-reorder';
  div.style.cssText='background:#F9F4EE;border-radius:10px;padding:12px 16px;margin:12px 0;display:flex;align-items:flex-start;gap:10px;border:.5px solid #EDE5DA';
  div.innerHTML='<span style="font-size:18px;flex-shrink:0"></span><div><p style="font-size:13px;font-weight:600;color:#2B2926;margin-bottom:2px">Need this regularly?</p><p style="font-size:12px;color:#6B6560;line-height:1.5">Create a free account and we\'ll remind you when it\'s time to reorder -- no subscription required.</p><a href="/account/register" style="font-size:12px;font-weight:600;color:#E0948F;text-decoration:none;display:inline-block;margin-top:4px">Set up a reorder reminder \u2192</a></div>';
  form.insertAdjacentElement('afterend',div);
})();

/* 8. Product card hover enhancement */
(function(){
  var style=document.createElement('style');
  style.textContent='.card-wrapper:hover .card{border-color:#CA9365 !important;transition:border-color .2s ease}';
  document.head.appendChild(style);
})();



/* Fix: replace old <h3>Menu</h3> in mobile panel with search form */
(function(){
  var header = document.querySelector('.wwp-mm-header');
  if(!header) return;
  var h3 = header.querySelector('h3');
  if(!h3) return; // already has search form, nothing to do
  var form = document.createElement('form');
  form.className = 'wwp-mm-search-form';
  form.method = 'get';
  form.action = '/search';
  form.setAttribute('role','search');
  form.innerHTML = '<input type="search" name="q" placeholder="Search for pet products..." aria-label="Search" style="flex:1;min-width:0;border:none;background:transparent;padding:9px 6px 9px 16px;font-size:1.3rem;color:#2B2926;outline:none">' +
    '<button type="submit" aria-label="Search" style="border:none;background:#E0948F;color:#FFFDFB;padding:0 16px;align-self:stretch;display:flex;align-items:center;cursor:pointer">' +
    '<svg viewBox="0 0 18 19" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="7" cy="7" r="5"/><line x1="11" y1="11" x2="16" y2="16"/></svg></button>';
  form.style.cssText = 'flex:1 1 auto;display:flex;align-items:center;border:1px solid #CA9365;border-radius:40px;overflow:hidden;background:#FFFDFB;min-width:0';
  h3.replaceWith(form);
})();

});

/* ---- BELOW ADDED IN PATCH v4 ---- */

document.addEventListener('DOMContentLoaded', function(){

/* 10. Sticky mobile Add to Bag bar */
(function(){
  if(window.innerWidth >= 750) return;
  var isProduct = document.querySelector('.product-form');
  if(!isProduct || document.querySelector('.wwp-sticky-atc')) return;

  var bar = document.createElement('div');
  bar.className = 'wwp-sticky-atc';
  bar.style.cssText = 'position:fixed;bottom:0;left:0;right:0;background:#FFFDFB;border-top:.5px solid #EDE5DA;padding:10px 16px 20px;z-index:200;display:none;box-shadow:0 -4px 16px rgba(0,0,0,.08)';

  var title = document.querySelector('.product__title h1,.product__title');
  var titleText = title ? title.textContent.trim().substring(0,38) + (title.textContent.trim().length > 38 ? '...' : '') : '';

  var inner = document.createElement('div');
  inner.style.cssText = 'display:flex;align-items:center;gap:12px;max-width:600px;margin:0 auto';

  if(titleText){
    var t = document.createElement('p');
    t.textContent = titleText;
    t.style.cssText = 'font-size:12px;color:#6B6560;line-height:1.3;flex:1;min-width:0;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical';
    inner.appendChild(t);
  }

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.textContent = 'Add to Bag';
  btn.style.cssText = 'flex-shrink:0;background:#E0948F;color:#FFFDFB;font-size:14px;font-weight:700;padding:13px 22px;border:none;border-radius:10px;cursor:pointer;transition:background .15s;letter-spacing:.01em;white-space:nowrap';
  btn.addEventListener('mouseenter',function(){btn.style.background='#CA9365'});
  btn.addEventListener('mouseleave',function(){btn.style.background='#E0948F'});
  btn.addEventListener('click',function(){
    var real = document.querySelector('[name="add"]:not(.wwp-sticky-atc *),.product-form__submit:not(.wwp-sticky-atc *)');
    if(real) real.click();
  });
  inner.appendChild(btn);
  bar.appendChild(inner);
  document.body.appendChild(bar);

  var realAtc = document.querySelector('.product-form__submit,[name="add"]');
  if(realAtc){
    new IntersectionObserver(function(entries){
      bar.style.display = entries[0].isIntersecting ? 'none' : 'block';
    },{threshold:0.2}).observe(realAtc);
  }
})();

/* 11. Product page trust strip under Add to Bag */
(function(){
  var form = document.querySelector('.product-form');
  if(!form || form.querySelector('.wwp-pdp-trust')) return;
  var strip = document.createElement('div');
  strip.className = 'wwp-pdp-trust';
  strip.style.cssText = 'display:flex;gap:12px;justify-content:center;flex-wrap:wrap;padding:12px 0 0;margin-top:4px;border-top:.5px solid #EDE5DA';
  var items = [['&#10003;','Tracked delivery'],['&#10003;','Easy returns'],['&#10003;','Secure checkout']];
  strip.innerHTML = items.map(function(x){
    return '<span style="font-size:12px;color:#6B6560;display:flex;align-items:center;gap:4px;font-weight:500"><span style="color:#CA9365;font-weight:700">'+x[0]+'</span>'+x[1]+'</span>';
  }).join('');
  form.appendChild(strip);
})();

/* 12. Scroll-to-reviews shortcut when stars are visible */
(function(){
  var stars = document.querySelector('.rating,.product__rating');
  if(!stars || document.querySelector('.wwp-review-link')) return;
  var reviews = document.querySelector('#shopify-product-reviews,.review-section,.spr-reviews,[id*="reviews"]');
  if(!reviews) return;
  var a = document.createElement('a');
  a.className = 'wwp-review-link';
  a.href = '#';
  a.textContent = 'Read reviews';
  a.style.cssText = 'font-size:12px;color:#CA9365;text-decoration:underline;display:inline-block;margin-left:6px;vertical-align:middle';
  a.addEventListener('click',function(e){
    e.preventDefault();
    reviews.scrollIntoView({behavior:'smooth',block:'start'});
  });
  stars.appendChild(a);
})();

/* 13. Cart count pulse on add-to-cart */
(function(){
  document.querySelectorAll('[name="add"],.product-form__submit').forEach(function(btn){
    if(btn.dataset.wwpPulse) return;
    btn.dataset.wwpPulse = 'true';
    btn.addEventListener('click',function(){
      setTimeout(function(){
        var badge = document.querySelector('.cart-count-bubble,.header__cart-count');
        if(badge){
          badge.style.transform = 'scale(1.4)';
          badge.style.transition = 'transform .15s';
          setTimeout(function(){badge.style.transform='scale(1)'},200);
        }
      },600);
    });
  });
})();

}); /* end DOMContentLoaded v4 */
